import { webAppBffApiClient } from '@mi-front/api-clients';
import { useMemo } from 'react';

export type SubtitleDownloadUrls = {
  txt: string;
  srt: string;
  json: string;
};

/**
 * Builds signed GET URLs for fragment subtitle exports (Web App BFF).
 * Recomputes when the fragment id or speaker-id option changes.
 */
export function useFragmentSubtitleDownloadUrls(
  fragmentId: string | undefined,
  withSpeakerId: boolean,
): SubtitleDownloadUrls | null {
  return useMemo(() => {
    if (!fragmentId) {
      return null;
    }

    const path = `/fragments/${fragmentId}/subtitles`;
    const common = { download: true as const, withSpeakerId };

    return {
      txt: webAppBffApiClient.generateUrl(path, { ...common, format: 'txt' }),
      srt: webAppBffApiClient.generateUrl(path, { ...common, format: 'srt' }),
      json: webAppBffApiClient.generateUrl(path, { ...common, format: 'json' }),
    };
  }, [fragmentId, withSpeakerId]);
}
